import * as React from 'react';
import { FormControl } from './FormControl';
import { FormControlHelperText } from './FormControlHelperText';
import { FormControlLabel } from './FormControlLabel';
const TEST_ID = 'doppio-form-control-group';
export const FormControlGroup = React.forwardRef(({ id, formElementId, label, labelTooltip, helperText, isInvalid, isRequired, isDisabled, children, }, forwardedRef) => {
    const formGroupId = id || `${formElementId}-form-group`;
    const helperTextId = formElementId && `${formElementId}-helper-text`;
    const shouldRenderLabel = Boolean(label);
    const shouldRenderHelperText = Boolean(helperText);
    let childrenEl = children;
    if (React.isValidElement(children)) {
        childrenEl = React.cloneElement(React.Children.only(children), { helperTextId });
    }
    else if (typeof children === 'function') {
        childrenEl = children({ helperTextId });
    }
    return (React.createElement(FormControl, { id: formGroupId, ref: forwardedRef, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid },
        shouldRenderLabel && (React.createElement(FormControlLabel, { labelTooltip: labelTooltip, labelFor: formElementId }, label)),
        childrenEl,
        shouldRenderHelperText && (React.createElement(FormControlHelperText, { id: helperTextId }, helperText))));
});
Object.assign(FormControlGroup, { displayName: 'FormControlGroup', testID: TEST_ID });
//# sourceMappingURL=FormControlGroup.js.map